export const columna = [

	

	{
	"nombre": "Noticias.",
	"imagen": "noticias/lolotla.jpg",
	"funcion": "Lolotla dio cuenta de los avances de su administración en el #2doInformeLolotla de la presidenta municipal María Díaz Bustos, con resultados en favor de las familias y comunidades. En representación del gobernador Julio Menchaca, Claudia López, directora general de Responsabilidades Administrativas, acompañó este ejercicio de rendición de cuentas.",
	"url": "https://www.facebook.com/share/p/1NDSijY3r3"
	},
	{
	"nombre": "Noticias.",
	"imagen": "noticias/tlanchinol.jpg",
	"funcion": "Tlanchinol compartió una mirada a los resultados de su administración en el #2doInformeTlanchinol, encabezado por el alcalde Gabino Hernández Vite. Briseyda Torres Martínez estuvo presente en representación del gobernador Julio Menchaca.",
	"url": "https://www.facebook.com/reel/2018963048872129/?rdid=timHUw7t6T3DDm2K&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2Fv%2F19JdXTMa3s#"
	},

	{
	"nombre": "Noticias.",
	"imagen": "noticias/actividadescontraloria.jpg",
	"funcion": "Conoce las actividades de la Contraloría esta semana. En representación del gobernador Julio Menchaca, acompañamos los segundos informes de gobierno municipales.",
	"url": "https://www.facebook.com/reel/2944511592576711"
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]